// extracted by mini-css-extract-plugin
export var actions = "_1l-0";
export var actionsContainer = "_1l-7";
export var border = "_1l-1";
export var childFullHeight = "_1l-f";
export var collapse = "_1l-2";
export var content = "_1l-a";
export var contentChild = "_1l-e";
export var fullscreen = "_1l-c";
export var hasLeftRadius = "_1l-k";
export var headerContainer = "_1l-3";
export var headerRow = "_1l-5";
export var hidePadding = "_1l-b";
export var navCollapsedGap = "_1l-l";
export var noScrollX = "_1l-m";
export var noScrollY = "_1l-n";
export var noTopPadding = "_1l-i";
export var optOutTopPadding = "_1l-d";
export var pageMain = "_1l-j";
export var pageOuter = "_1l-g";
export var pagePadding = "_1l-8";
export var pageScroll = "_1l-9";
export var profile = "_1l-o";
export var profileContainer = "_1l-p";
export var profileImage = "_1l-q";
export var profileMain = "_1l-r";
export var profileSubtitle = "_1l-t";
export var profileTitle = "_1l-s";
export var showLeftPadding = "_1l-h";
export var tabsPortalSlot = "_1l-6";
export var tabsWrapper = "_1l-4";
export var title = "_1l-u";